export default __webpack_public_path__ + "static/checksmart-opengraph-90ec744a2569534e468c2335c328bb34.png";